import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

/**
 * Generic Search + Filter + Sort + Reset toolbar.
 * filters: [{ key, label, options: [{value,label}], value }]
 * sorts: [{value,label}]
 */
export default function ListToolbar({
  search, setSearch, filters = [], onFilter, sort, setSort, sorts = [], onReset, placeholder = "Search...",
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 bg-card border rounded-xl p-3">
      <div className="relative flex-1 min-w-[180px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          data-testid="toolbar-search"
          value={search || ""}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-9"
        />
      </div>

      {filters.map((f) => (
        <Select key={f.key} value={f.value || "all"} onValueChange={(v) => onFilter(f.key, v === "all" ? "" : v)}>
          <SelectTrigger data-testid={`filter-${f.key}`} className="w-auto min-w-[130px]">
            <SelectValue placeholder={f.label} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{f.label}: All</SelectItem>
            {f.options.map((o) => (
              <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ))}

      {sorts.length > 0 && (
        <Select value={sort} onValueChange={setSort}>
          <SelectTrigger data-testid="toolbar-sort" className="w-auto min-w-[140px]">
            <SelectValue placeholder="Sort By" />
          </SelectTrigger>
          <SelectContent>
            {sorts.map((s) => (
              <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      <Button data-testid="toolbar-reset" variant="ghost" onClick={onReset} className="gap-1 text-muted-foreground">
        <X className="h-4 w-4" /> Clear Filters
      </Button>
    </div>
  );
}
